var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeso(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Icon-24px-Peso_Balance",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:none}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-24px-Peso_Balance-2",
    opacity: 0.802
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_132",
    d: "M0 0H38V38H0z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_43",
    fill: "#1b80c5",
    stroke: "#fff",
    transform: "translate(1.576 1.576)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.332,
    cy: 17.332,
    r: 17.332,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.332,
    cy: 17.332,
    r: 16.832,
    className: "cls-2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_735",
    fill: "#fff",
    d: "M3.922 1.7V.124h5.625a3.19 3.19 0 0 1-3 1.573zm2.629-6.941a3.166 3.166 0 0 1 3.006 1.573H3.922v-1.573zm-2.629 2.65h5.99a4.91 4.91 0 0 1 .065.808 5.08 5.08 0 0 1-.065.83h-5.99zM13.1-3.776h-1.5a4.718 4.718 0 0 0-4.575-3.167H1.983v3.168H.41v1.293h1.573v1.422H.41V.232h1.573v8.135h1.939V3.4h3.093A4.738 4.738 0 0 0 11.594.232H13.1v-1.293h-1.2a5.3 5.3 0 0 0 .043-.722 4.99 4.99 0 0 0-.043-.7h1.2z",
    transform: "translate(12.841 18.412)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeso);
export default __webpack_public_path__ + "static/media/peso.1fc2dfb0f7afad5d9639dee039351d03.svg";
export { ForwardRef as ReactComponent };